import * as React from "react";

export const RightActiveArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={10}
    viewBox="0 0 7 10"
    {...props}
  >
    <path
      id="Polygon_34"
      data-name="Polygon 34"
      d="M5,0l5,7H0Z"
      transform="translate(7) rotate(90)"
      fill="#12aac4"
    />
  </svg>
);
export const RightArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={10}
    viewBox="0 0 7 10"
    {...props}
  >
    <path
      id="Polygon_51"
      data-name="Polygon 51"
      d="M5,0l5,7H0Z"
      transform="translate(7) rotate(90)"
      fill="#c7c7c9"
    />
  </svg>
);

export const LeftActiveArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={10}
    viewBox="0 0 7 10"
    {...props}
  >
    <path
      id="Polygon_36"
      data-name="Polygon 36"
      d="M5,0l5,7H0Z"
      transform="translate(0 10) rotate(-90)"
      fill="#12aac4"
    />
  </svg>
);

export const LeftArrow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7}
    height={10}
    viewBox="0 0 7 10"
    {...props}
  >
    <path
      id="Polygon_50"
      data-name="Polygon 50"
      d="M5,0l5,7H0Z"
      transform="translate(0 10) rotate(-90)"
      fill="#c7c7c9"
    />
  </svg>
);
